// src/app/components/visual-panel/visual-panel.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisualPanelComponent } from './visual-panel.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    VisualPanelComponent
  ],
  exports: [
    VisualPanelComponent
  ]
})
export class VisualPanelModule { }